import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useShareDetailsPage } from '../context/ShareDetailsPageContext';
import OwnershipCard from './OwnershipCard';
import FinancialsCard from './FinantialCard';

import EncumbrancesSection from './EncumbrancesSection';

const ShareDetailsPageBody: FC = () => {
  const { data, actions } = useShareDetailsPage();

  // const showPagination =
  //   data.holdingClasses && data.holdingClassesTotal > (data.rowsPerPage || 10);

  return (
    <div className="share-details-page-body">
      {/* <OwnershipCard />
      <FinancialsCard /> */}

      <EncumbrancesSection />
    </div>
  );
};

export default ShareDetailsPageBody;
